import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Footer, Header } from "../../components";
import { Commons } from "../../utilities";

const AppLayout = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
    const location = useLocation();
    const className = Commons.getClassNameFromPath(location.pathname);
    return (
        <div className="App-main">
            <Header.Header />
            <main className={className}>
                <Outlet />
            </main>
            <Footer.Footer />
        </div>
    );
};

export default AppLayout;
